import React, { useContext, useEffect, useRef, useState } from "react";
import ChannelDetail from "../../components/channelDetail";
import { SessionContext } from "../../context/SessionContext";
import ModalRouting from "../../components/modalRouting/ModalRouting";
import { Link, useHistory, useParams } from "react-router-dom";
import ChannelListWidget from "../../components/channelListWidget/ChannelListWidget";
import localizationStrings from "../../statics/localization";
import { getChannels, toggleLockById } from "../../api/ltv/ltv";
import {
  getLiveCategories,
  getLiveCategoryChannels,
  getLiveChannelById
} from "../../api/ltv/liveCatalog";
import FilterAllIcon from "../../assets/icons/svg/FilterAllIcon";
import TvGuideIcon from "../../assets/icons/svg/TvGuideIcon";
import SearchCloseIcon from "../../assets/icons/svg/SearchCloseIcon";
import { enableBodyScroll } from "body-scroll-lock";
import SearchIcon from "../../assets/icons/svg/SearchIcon";
import { postAnalyticsLtvWatch } from "../../api/analytics/analyticsApi";

import { getBroadcastCopy } from "../../statics/broadcastCopy";
import CinemaIcon from "../../components/cinema/CinemaIcon";
import { searchChannels } from "../../components/tvGuideRow/guideTimeline";
import { onGuideIntent } from "../../api/ltv/prewarmGuide";
import LiveCategorySelect from "./LiveCategorySelect";

const LiveTv = () => {
  const copy = getBroadcastCopy();
  const [channelStatus, setChannelStatus] = useState("loading");
  const [genres, setGenres] = useState([]);
  const [categoryStatus, setCategoryStatus] = useState("loading");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [term, setTerm] = useState("");
  const [itemCount, setItemCount] = useState(null);
  const [allChannelsVar, setAllChannelsVar] = useState(null);

  const {
    selectedChannel,
    setSelectedChannel,
    userFrameConfig,
    setPath,
    isChangeLockChannel,
    setSelectedCutvProgram,
    isChildProfile,
    setIsChangeLockChannel,
    currentProgramTimes,
    setCurrentProgramTimes,
    adminProfile,
    profile,
    selectedGenre,
    setSelectedGenre,
    channelItems,
    setChannelItems
  } = useContext(SessionContext);
  const history = useHistory();
  const intervalId = useRef(null);
  const filterTimeoutId = useRef(null);
  const inputRef = useRef(null);
  const allChannels = useRef([]);
  const analticsData = useRef({ startTime: null, id: null });
  const mounted = useRef(true);
  const categoryRequest = useRef(0);
  const channelRequest = useRef(0);

  let { channelNo } = useParams();
  const activeCategoryId = genres.find(
    (genre) => genre.id === selectedGenre?.id
  )?.id;
  const latest = useRef({});
  latest.current = { activeCategoryId, channelNo, selectedChannel };

  useEffect(() => {
    mounted.current = true;
    window.scrollTo(0, 0);

    return () => {
      mounted.current = false;
      categoryRequest.current += 1;
      channelRequest.current += 1;
      clearTimeout(filterTimeoutId.current);
      clearInterval(intervalId.current);
    };
  }, []);

  useEffect(() => {
    let active = true;
    if (channelNo && allChannelsVar) {
      const pickedChannel = allChannels.current.find(
        (channel) => channel?.id == channelNo
      );
      if (pickedChannel && pickedChannel.id !== selectedChannel?.id) {
        setSelectedCutvProgram(null);
        setSelectedChannel(pickedChannel);
      }
      if (!pickedChannel && channelNo !== "all" && channelNo !== "first") {
        getLiveChannelById(channelNo)
          .then((channel) => {
            if (!active) return;
            allChannels.current = [...allChannels.current, channel];
            setSelectedCutvProgram(null);
            setSelectedChannel(channel);
          })
          .catch(() => {
            if (active && !latest.current.selectedChannel?.id) {
              channelSelection(allChannelsVar[0]);
            }
          });
      }
    }
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    }
    return () => {
      active = false;
    };
  }, [channelNo, allChannelsVar]);

  // const setLiveAnalytics = (clear = false) => {
  //   if (
  //     (analticsData.current?.id !== channelNo || clear) &&
  //     analticsData.current?.startTime
  //   ) {
  //     sendLiveAnalytics(analticsData.current);
  //   }
  //   if (clear) {
  //     analticsData.current = { startTime: null, id: null };
  //   } else if (analticsData.current?.id !== channelNo) {
  //     const time = Date.now();
  //     analticsData.current = { startTime: time, id: channelNo };
  //   }
  // };

  const sendLiveAnalytics = async (id) => {
    if (profile?.id && id && id !== "all" && id !== "first") {
      const duration = "60"; //seconds
      // Channel ids are UUIDs in the legacy client contract too.
      try {
        await postAnalyticsLtvWatch(id, duration, profile.id);
      } catch (error) {
        // Reporting must not interrupt the active player.
      }
    }
  };

  // Refreshing the channel list must not restart the watch interval. Otherwise
  // its own 60-second poll can postpone reporting indefinitely after a zap.
  useEffect(() => {
    if (!selectedChannel?.id || !profile?.id) return;
    const timer = setInterval(() => sendLiveAnalytics(selectedChannel.id), 60000);
    return () => clearInterval(timer);
  }, [selectedChannel?.id, profile?.id]);

  const channelSelection = (item, isRefresh = false) => {
    if (!item?.id || !mounted.current) return;
    history.push(`/dashboard/livetv/${item?.id}`);
    setSelectedCutvProgram(null);
    if (isRefresh) {
      setSelectedChannel((prevState) => {
        let newObj = {};
        Object.assign(newObj, prevState);
        return newObj;
      });
    } else {
      setSelectedChannel(item);
    }
    setPath(`/dashboard/livetv/${item?.id}`);
  };

  const getChannelItems = async (background = false) => {
    const categoryId = latest.current.activeCategoryId;
    if (!categoryId) return;
    const request = ++channelRequest.current;
    if (!background) setChannelStatus("loading");
    const response = await (categoryId === "all"
      ? getChannels()
      : getLiveCategoryChannels(categoryId)
    ).catch(() => null);
    if (
      !mounted.current ||
      request !== channelRequest.current ||
      categoryId !== latest.current.activeCategoryId
    )
      return;
    if (!Array.isArray(response?.data)) {
      if (!background) setChannelStatus("error");
      return;
    }

    const channels = response.data;
    // Keep previously visited channels for browser Back, independently of the
    // active category/search. Only the current category is rendered in the list.
    // A full response is authoritative: a preference/package change can remove
    // channels that were visited earlier. Do not resurrect those from history.
    const knownChannels = new Map(
      (categoryId === "all" ? [] : allChannels.current).map((item) => [item.id, item])
    );
    channels.forEach((item) => knownChannels.set(item.id, item));
    allChannels.current = Array.from(knownChannels.values());
    setAllChannelsVar(channels);
    setChannelStatus("ready");

    const current = latest.current.selectedChannel;
    const updated = channels.find((item) => item.id === current?.id);
    if (updated) {
      setSelectedChannel({ ...updated, parentalUnlocked: current.parentalUnlocked });
    } else if (categoryId === "all" && current?.id) {
      setSelectedCutvProgram(null);
      setSelectedChannel(null);
    }
    const routeChannel = allChannels.current.find(
      (item) =>
        item.id === latest.current.channelNo ||
        item.channelcode === latest.current.channelNo
    );
    if (routeChannel && routeChannel.id !== current?.id) {
      setSelectedCutvProgram(null);
      setSelectedChannel(routeChannel);
    } else if (
      !routeChannel &&
      (!current?.id || (categoryId === "all" && !updated)) &&
      [undefined, "all", "first"].includes(latest.current.channelNo)
    ) {
      channelSelection(channels[0]);
    }
  };

  const getCategories = async () => {
    const request = ++categoryRequest.current;
    channelRequest.current += 1;
    setCategoryStatus("loading");
    setChannelStatus("loading");
    setGenres([]);
    setAllChannelsVar(null);
    setChannelItems([]);
    allChannels.current = [];
    try {
      const categories = await getLiveCategories();
      if (!mounted.current || request !== categoryRequest.current) return;
      const allCategory = { id: "all", name: copy.all };
      setSelectedGenre(allCategory);
      setGenres([allCategory, ...categories.filter(category => String(category.id) !== "2")]);
      setCategoryStatus("ready");
    } catch (error) {
      if (!mounted.current || request !== categoryRequest.current) return;
      setCategoryStatus("error");
      setChannelStatus("error");
    }
  };

  useEffect(() => {
    getCategories();
  }, [profile?.id]);

  useEffect(() => {
    if (channelNo === "all" || channelNo === "first") {
      setSelectedGenre({ id: "all", name: copy.all });
      setTerm("");
    }
  }, [channelNo, copy.all, setSelectedGenre]);

  useEffect(() => {
    // The tab also resets filters when HashRouter is already on /livetv/all.
    if (selectedGenre?.id === "all") setTerm("");
  }, [selectedGenre]);

  useEffect(() => {
    setPath(`/dashboard/livetv/${channelNo}`);
  }, []);

  useEffect(() => {
    if (isChangeLockChannel) {
      getChannelItems(true);
    }
    return () => {
      setIsChangeLockChannel(false);
    };
  }, [isChangeLockChannel]);

  useEffect(() => {
    if (selectedChannel) {
      let obj = {
        begintime: selectedChannel.begintime,
        endtime: selectedChannel.endtime
      };
      setCurrentProgramTimes(obj);
    }
  }, [selectedChannel]);

  useEffect(() => {
    channelRequest.current += 1;
    setAllChannelsVar(null);
    setChannelItems([]);
    if (!activeCategoryId) return;
    getChannelItems();
    // Refresh only the selected category; discard responses from previous ones.
    const timer = setInterval(() => getChannelItems(true), 60000);
    return () => {
      clearInterval(timer);
      channelRequest.current += 1;
    };
  }, [activeCategoryId]);

  useEffect(() => {
    setChannelItems(searchChannels(allChannelsVar || [], term));
  }, [allChannelsVar, term]);

  const getChannelForInterval = () => getChannelItems(true);
  const filterChannels = (input) => setTerm(input);
  const switcherChannels =
    selectedChannel?.id &&
    allChannels.current.some((channel) => channel.id === selectedChannel.id) &&
    !allChannelsVar?.some((channel) => channel.id === selectedChannel.id)
      ? [selectedChannel, ...(allChannelsVar || [])]
      : allChannelsVar || [];

  return (
    <div className="container atlas-live atlas-broadcast">
      <header className="broadcast-heading">
        <div>
          <span className="broadcast-eyebrow">
            <i className="broadcast-live-dot" />
            {copy.onAir}
          </span>
          <h1>{copy.live}</h1>
          <p>{copy.liveNote}</p>
        </div>
        <Link
          className="broadcast-link"
          to="/dashboard/tvguide"
          onMouseEnter={onGuideIntent}
          onFocus={onGuideIntent}
          onTouchStart={onGuideIntent}
        >
          <CinemaIcon name="tv" />
          {copy.guide}
          <CinemaIcon name="arrow" />
        </Link>
      </header>

      <label className="live-mobile-switcher">
        <span>{copy.channels}</span>
        <select
          aria-label={copy.watch}
          value={selectedChannel?.id || ""}
          onChange={(event) => {
            const channel = switcherChannels.find(
              (item) => String(item.id) === event.target.value
            );
            if (channel) channelSelection(channel);
          }}
        >
          {switcherChannels.map((channel) => (
            <option key={channel.id} value={channel.id}>
              {channel.name}
            </option>
          ))}
        </select>
      </label>
      <div className={`channel-container ${isFilterOpen ? "extend" : ""}`}>
        <div
          className={`channel-detail-column ${isFilterOpen ? "extend" : ""}`}
        >
          <div className="detail-wrapper">
            <div className="channel-detail-box">
              <ChannelDetail
                selectedChannel={selectedChannel}
                channels={channelItems}
                genres={genres}
                selectedGenre={selectedGenre}
                setSelectedGenre={(val) => {
                  setSelectedGenre(val);
                  setTerm("");
                  setIsFilterOpen(false);
                }}
                searchFilter={(val) => {
                  filterChannels(val);
                  if (val.length) {
                    setTerm(val);
                    setIsSearchOpen(true);
                  } else {
                    setIsSearchOpen(false);
                    setTerm("");
                  }
                }}
                setCanWatch={(canWatch) => {
                  if (canWatch) {
                    setSelectedChannel((prevState) => {
                      let newObj = {};
                      prevState.parentalUnlocked = true;
                      Object.assign(newObj, prevState);
                      return newObj;
                    });
                    getChannelItems(true);
                  }
                }}
                setFavChannelCode={(channelId, isFav) => {
                  // Update function for channel interactions
                  const updateChannelInteractions = (item) => {
                    if (item.id === channelId) {
                      // Check if 'isFav' is true, add 'CHANNEL_FAV', otherwise remove it
                      if (isFav) {
                        item.interactions = [
                          ...item.interactions,
                          "CHANNEL_FAV"
                        ];
                      } else {
                        item.interactions = item.interactions.filter(
                          (interaction) => interaction !== "CHANNEL_FAV"
                        );
                      }
                    }
                    return item;
                  };

                  // Update channelItems state
                  setChannelItems((prevState) => {
                    return (prevState || []).map(updateChannelInteractions);
                  });

                  // Update allChannelsVar state for consistency
                  setAllChannelsVar((prevState) => {
                    return (prevState || []).map(updateChannelInteractions);
                  });

                  // Update allChannels ref for consistency
                  if (allChannels.current) {
                    allChannels.current = allChannels.current.map(
                      updateChannelInteractions
                    );
                  }
                  getChannelItems(true); // Favorites can change membership of the active category.
                }}
                setLockChannelCode={(channelId, isLocked) => {
                  // Update function for channel interactions
                  const updateChannelInteractions = (item) => {
                    if (item.id === channelId) {
                      item.islocked = isLocked ? "1" : "0";
                      item.isLocked = !!isLocked;
                      if (isLocked) {
                        item.canWatch = false;
                        item.parentalUnlocked = false;
                      }
                      // Check if 'locked' is true, add 'CHANNEL_LOCK', otherwise remove it
                      if (isLocked) {
                        item.interactions = [
                          ...item.interactions,
                          "CHANNEL_LOCK"
                        ];
                      } else {
                        item.interactions = item.interactions.filter(
                          (interaction) => interaction !== "CHANNEL_LOCK"
                        );
                      }
                    }
                    return item;
                  };

                  // Update channelItems state
                  setChannelItems((prevState) => {
                    return (prevState || []).map(updateChannelInteractions);
                  });

                  // Update allChannelsVar state for consistency
                  setAllChannelsVar((prevState) => {
                    return (prevState || []).map(updateChannelInteractions);
                  });

                  // Update allChannels ref for consistency
                  if (allChannels.current) {
                    allChannels.current = allChannels.current.map(
                      updateChannelInteractions
                    );
                  }
                  getChannelItems(true); // Refresh islocked, canWatch and timeshift flags from MW.
                }}
              />
            </div>
          </div>
        </div>
        <div className={`channel-list-column ${isFilterOpen ? "extend" : ""}`}>
          <div className="live-channel-heading">
            <h2>{copy.channels}</h2>
            <span>{channelItems?.length || 0}</span>
          </div>
          <label className="broadcast-search">
            <CinemaIcon name="search" />
            <input
              type="search"
              aria-label={copy.search}
              placeholder={copy.search}
              value={term}
              onChange={(event) => setTerm(event.target.value)}
            />
            {term && (
              <button
                type="button"
                aria-label={copy.clear}
                onClick={() => setTerm("")}
              >
                <CinemaIcon name="close" />
              </button>
            )}
          </label>
          <LiveCategorySelect
            label={copy.category}
            categories={genres}
            value={activeCategoryId}
            disabled={categoryStatus !== "ready" || !genres.length}
            onChange={setSelectedGenre}
          />
          {channelStatus === "error" ? (
            <div className="broadcast-empty" role="alert">
              {copy.channelError}
              <button
                onClick={() =>
                  categoryStatus === "error"
                    ? getCategories()
                    : getChannelItems()
                }
              >
                {copy.retry}
              </button>
            </div>
          ) : channelStatus === "loading" ? (
            <div className="broadcast-empty" role="status">
              {copy.loading}
            </div>
          ) : (
            !channelItems?.length && (
              <div className="broadcast-empty">{copy.noChannels}</div>
            )
          )}
          <ChannelListWidget
            key="channellist-1"
            uKey="channellist-1"
            trackIdPrefix="livetv_channel"
            channels={channelItems}
            genres={genres}
            selectedGenre={selectedGenre}
            setSelectedGenre={(val) => {
              setSelectedGenre(val);
              setTerm("");
              setIsSearchOpen(false);
              setItemCount(null);
            }}
            selectedChannel={selectedChannel}
            setSelectedChannel={setSelectedChannel}
            onSelectChannel={channelSelection}
            isChangeLockChannel={isChangeLockChannel}
            setSelectedCutvProgram={() => {
              /* setSelectedCutvProgram(null); */
            }}
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            adminProfile={adminProfile}
            profile={profile}
            userFrameConfig={userFrameConfig}
            setLockChannelCode={(channelId, isLocked) => {
              if (channelId) {
                //debugger;
                let updatedChannel = null;

                // Update function for channel interactions
                const updateChannelInteractions = (item) => {
                  if (item.id === channelId) {
                    item.islocked = isLocked ? "1" : "0";
                      item.isLocked = !!isLocked;
                      if (isLocked) {
                        item.canWatch = false;
                        item.parentalUnlocked = false;
                      }
                      // Check if 'locked' is true, add 'CHANNEL_LOCK', otherwise remove it
                    if (isLocked) {
                      item.interactions = [
                        ...item.interactions,
                        "CHANNEL_LOCK"
                      ];
                    } else {
                      item.interactions = item.interactions.filter(
                        (interaction) => interaction !== "CHANNEL_LOCK"
                      );
                    }
                    updatedChannel = { ...item };
                  }
                  return item;
                };

                // Update channelItems state
                setChannelItems((prevState) => {
                  return (prevState || []).map(updateChannelInteractions);
                });

                // Update allChannelsVar state for consistency
                setAllChannelsVar((prevState) => {
                  return (prevState || []).map(updateChannelInteractions);
                });

                // Update allChannels ref for consistency
                if (allChannels.current) {
                  allChannels.current = allChannels.current.map(
                    updateChannelInteractions
                  );
                }

                // If this is the currently selected channel, update its state too
                if (updatedChannel) {
                  setSelectedChannel((prevSelected) => {
                    if (prevSelected && prevSelected.id === channelId) {
                      return updatedChannel;
                    }
                    return prevSelected;
                  });
                }
              }
              getChannelItems(true); // An interaction-only update leaves the player locked after unlock.
            }}
            setFavChannelCode={(channelId, isFav) => {
              if (channelId) {
                let updatedChannel = null;

                // Update function for channel interactions
                const updateChannelInteractions = (item) => {
                  if (item.id === channelId) {
                    // Check if 'isFav' is true, add 'CHANNEL_FAV', otherwise remove it
                    if (isFav) {
                      item.interactions = [...item.interactions, "CHANNEL_FAV"];
                    } else {
                      item.interactions = item.interactions.filter(
                        (interaction) => interaction !== "CHANNEL_FAV"
                      );
                    }
                    updatedChannel = { ...item };
                  }
                  return item;
                };

                // Update channelItems state
                setChannelItems((prevState) => {
                  return (prevState || []).map(updateChannelInteractions);
                });

                // Update allChannelsVar state for consistency
                setAllChannelsVar((prevState) => {
                  return (prevState || []).map(updateChannelInteractions);
                });

                // Update allChannels ref for consistency
                if (allChannels.current) {
                  allChannels.current = allChannels.current.map(
                    updateChannelInteractions
                  );
                }

                // If this is the currently selected channel, update its state too
                if (updatedChannel) {
                  setSelectedChannel((prevSelected) => {
                    if (prevSelected && prevSelected.id === channelId) {
                      return updatedChannel;
                    }
                    return prevSelected;
                  });
                }
              }
              getChannelItems(true); // Remove unfavorited channels from the favorites category.
            }}
            setCanWatch={(canWatch) => {
              //debugger;
              if (canWatch) {
                setSelectedChannel((prevState) => {
                  let newObj = {};
                  prevState.parentalUnlocked = true;
                  Object.assign(newObj, prevState);
                  return newObj;
                });
                getChannelForInterval();
              }
            }}
          />
        </div>
      </div>
      <ModalRouting />
    </div>
  );
};

export default LiveTv;
